var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 74,
    viewBox: "0 0 89 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 43.607,
    fill: "#bd591d",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38.522 74c-4.649-6.607-23.91-17.84-18.597-23.125 5.314-5.286 13.948 7.268 13.948 1.321v-27.75c0-5.285 9.299-5.946 9.299 0v13.875c0-4.625 9.298-6.15 9.298 1.322 0-3.964 9.299-4.17 9.299 1.982 0-2.455 8.27-2.65 8.27 4.417 0 7.476.664 11.44-4.95 27.958H38.523z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.459a7a4ebe77176d5f9634520a0688ee.svg";
export { ForwardRef as ReactComponent };